import { SearchPage } from './SearchPage';
import { CoveoSearchEngineProvider } from './CoveoSearchEngine';
import './CoveoSearch.scss';
export function CoveoSearchPage() {
  return <SearchPageWrapper analyticsEnabled={true} searchOnLoad={true} />;
}
interface SearchPageWrapperProps {
  analyticsEnabled: boolean;
  searchOnLoad: boolean;
}
export function SearchPageWrapper({ analyticsEnabled, searchOnLoad }: SearchPageWrapperProps) {
  return (
    <CoveoSearchEngineProvider analyticsEnabled={analyticsEnabled}>
      <SearchPage searchOnLoad={searchOnLoad} />
    </CoveoSearchEngineProvider>
  );
}

export default CoveoSearchPage;
